import React from "react";
import * as S from "./style";

// import { orderDetails } from "../order-details/constant";

import { getOrderColumns } from "./getOrderColumn";

import { PriceBreakdown } from "./priceBreakdown";
import Table from "@components/table";
import ButtonWrapper from "@components/wrapper/button-wrapper";
import Button from "@components/button";
import { DollarSign, Printer } from "lucide-react";
import OrderInfo from "./orderInfo";
import { useDispatch, useSelector } from "react-redux";
import { Actions, RootState } from "@store/index";

import { useNavigate, useSearchParams } from "react-router-dom";
import { edit } from "@assets/icons";
import { useModal } from "@context/ModalContext";
import { Helper } from "@utils/index";
import { useGeneralSettings } from "@hooks/useGeneralSettings";
import useConfig from "@hooks/useConfig";

const OrderedProductDetails = ({ singleOrderDetails: order, refreshOrder }: any) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const isEditStore = useSelector((state: RootState) => state.editStore);
  const { bucketUrl } = useConfig();
  const { settings } = useGeneralSettings();
  // const order = orderDetails[0]; // Removed hardcoded
  const columns: any = getOrderColumns(bucketUrl, settings);
  const navigate = useNavigate();
  const { showModal, hideModal } = useModal();
  const user = Helper.getUser();

  // Construct breakdown from order
  // Backend calculates actualAmount = productAmountAfterDiscount + deliveryCharge + deliveryManTip + processingPrice

  const breakdown = order?.financialSummary?.breakdown || {};
  const financialSummary = order?.financialSummary || {};

  // Customer-facing breakdown - using backend calculated values
  const priceBreakdown = {
    // Customer payment details
    originalAmount: order?.totalAmount || breakdown.originalAmount || 0,
    activeDealDiscount: breakdown.activeDealDiscount || 0,
    discount: order?.discountAmount ? -order.discountAmount : 0,
    productAmountAfterDiscount:
      breakdown.productAmountAfterDiscount ||
      (order?.totalAmount || 0) - (order?.discountAmount || 0),
    processingPrice: order?.processingPrice || 0,
    deliveryCharge: order?.deliveryCharge || breakdown.deliveryCharge || 0,
    deliveryManTip: order?.deliveryManTip || breakdown.deliveryManTip || 0,
    customerTotal: order?.actualAmount || 0,

    // Store deductions (for admin/store view)
    couponDiscount: breakdown.couponDiscount?.total
      ? -breakdown.couponDiscount.total
      : 0,
    couponPaidByStore: breakdown.couponDiscount?.paidByStore
      ? -breakdown.couponDiscount.paidByStore
      : 0,
    couponPaidByAdmin: breakdown.couponDiscount?.paidByAdmin
      ? -breakdown.couponDiscount.paidByAdmin
      : 0,
    commissionCharge:
      order?.commissionCharge || breakdown.commissionCharge || 0,

    // Financial summary
    storeEarnings: financialSummary.storeEarnings,
    adminEarnings: financialSummary.adminEarnings,
    userSavings: financialSummary.userSavings,

    // Partial Payment info
    paidAmount: order?.paidAmount || 0,
    dueAmount: order?.dueAmount || 0,
  };
  return (
    <S.StyleOrderDetailContainer>
      <S.StyleOrderDetailTop>
        <OrderInfo order={order} refreshOrder={refreshOrder} />
      </S.StyleOrderDetailTop>
      <br />

      <Table columns={columns} data={order.items || []} hasSearchbar={false} />
      <br />
      <S.HorizontalLine />
      <PriceBreakdown
        breakdown={priceBreakdown}
        commissionBreakdown={order?.financialSummary?.commissionBreakdown}
        bucketUrl={bucketUrl}
      />
      <br />
    </S.StyleOrderDetailContainer>
  );
};

export default OrderedProductDetails;
